<template lang="pug">
router-link.edit-button.--base-color.--underline-effect(
  :to="{ name: 'editPostById', params: { id: postId } }"
) edit
</template>

<script>
export default {
  name: 'edit-button',
  props: {
    postId: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style lang="sass">
.edit-button
  display: inline-block
  margin-bottom: 0.5rem
  font-size: 1rem
  font-variant: all-small-caps

  &.--underline-effect
    --underline-effect-line-height: 2px
</style>
